import React from 'react'

import { StateProvider } from './store'
import Root from './Root'

export default function App() {
  return (
    <StateProvider>
      <Root />
    </StateProvider>
  );
}
